import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { formatPercentage } from 'common/formatters';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrPartnerStatCardV2 from 'client/components/SrPartnerStatCardV2/SrPartnerStatCardV2';

import branch from 'client/core/branch';

@branch((props) => ({
  partnerOverviewStats: ['partners', 'overviewStats', props.partner.id],
}))
class SrPartnerOverviewStats extends Component {
  static propTypes = {
    partnerOverviewStats: PropTypes.object,
  };

  render() {
    const { partnerOverviewStats } = this.props;

    if (!partnerOverviewStats) {
      return null;
    }

    const occupancyRate =
      partnerOverviewStats.allListings === 0
        ? 0
        : (partnerOverviewStats.allListings -
            partnerOverviewStats.listingsGoingToMarket -
            partnerOverviewStats.activeListings) /
          partnerOverviewStats.allListings;

    const occupancyRaTeTooltip = (
      <span>
        <SrBox marginBottom="15px">
          <SrText
            color="white"
            font="greycliff"
            size="21"
            lineHeight="30px"
            align="center"
            weight="500"
            display="block"
          >
            The math:
          </SrText>
          <SrText
            color="white"
            font="greycliff"
            size="16"
            lineHeight="25px"
            align="center"
            weight="500"
            display="block"
          >
            ("All Listings" - "Going to Market" - "Active" )
          </SrText>
          <SrText
            color="white"
            font="greycliff"
            size="16"
            lineHeight="25px"
            align="center"
            weight="500"
            display="block"
          >
            / "All Listings"
          </SrText>
        </SrBox>
        <SrText
          color="white"
          font="greycliff"
          size="21"
          lineHeight="30px"
          align="center"
          weight="500"
          display="block"
        >
          The numbers:
        </SrText>
        <SrText
          color="white"
          font="greycliff"
          size="16"
          lineHeight="25px"
          align="center"
          weight="500"
          display="block"
        >
          {`(${partnerOverviewStats.allListings} - ${partnerOverviewStats.listingsGoingToMarket} -
          ${partnerOverviewStats.activeListings}) / ${partnerOverviewStats.allListings}`}
        </SrText>
      </span>
    );

    const stats = [
      {
        iconUrl: '/images/stat-going-to-market.svg',
        total: partnerOverviewStats.listingsGoingToMarket,
        description: 'Going to Market',
        tooltipText:
          'Listings that are going to market and are not temporarily off market or needing to be resolved.', // eslint-disable-line max-len
      },
      {
        iconUrl: '/images/stat-active.svg',
        total: partnerOverviewStats.activeListings,
        description: 'Active',
        tooltipText: 'Listings that are active on market for renters to see.',
      },
      {
        iconUrl: '/images/partner-icon-person.svg',
        // eslint-disable-next-line max-len
        total:
          partnerOverviewStats.rentlinxLeads +
          partnerOverviewStats.supraShowings +
          partnerOverviewStats.srLeads +
          partnerOverviewStats.locatorTourLeads +
          partnerOverviewStats.partnerTourRequests,
        description: 'Leads',
      },
      {
        iconUrl: '/images/partner-icon-key.svg',
        total: partnerOverviewStats.supraShowings + partnerOverviewStats.toursCompleted,
        description: 'Tours',
      },
      {
        iconUrl: '/images/stat-pending-apps.svg',
        total: partnerOverviewStats.appsInProgress,
        description: 'Applications',
        tooltipText: 'Listings that have pending applications from renters.',
      },
      {
        iconUrl: '/images/stat-leased.svg',
        total: partnerOverviewStats.listingsLeased,
        description: 'Leased',
        tooltipText:
          'Listings where renters signed a lease. This is different than move-ins, some renters may not have moved in yet but signed the lease at this time.', // eslint-disable-line max-len
      },
      {
        iconUrl: '/images/stat-occupied.svg',
        total: formatPercentage(occupancyRate),
        description: 'Occupancy',
        tooltipText: occupancyRaTeTooltip,
        formatNumber: false,
      },
    ];

    return (
      <div>
        <div className="SrPartnerListingStats">
          <div className="SrPartnerListingStatsScrollContainer">
            <SrBox width="16px" flexShrink="0" />
            {stats.map((stat, index) => (
              <SrBox key={`listing-stat-${index.toString()}`} margin="0 16px 0 0">
                <SrPartnerStatCardV2
                  iconUrl={stat.iconUrl}
                  total={stat.total}
                  description={stat.description}
                  tooltipText={stat.tooltipText}
                  formatNumber={stat.formatNumber}
                />
              </SrBox>
            ))}
            <SrBox width="16px" flexShrink="0" />
          </div>
        </div>
      </div>
    );
  }
}

SrPartnerOverviewStats.displayName = 'SrPartnerOverviewStats';

export default SrPartnerOverviewStats;
